import { useNavigate } from 'react-router-dom';

import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import UserOutlined from '@ant-design/icons/UserOutlined';
import LogoutOutlined from '@ant-design/icons/LogoutOutlined';

import { useAdminAuth } from 'contexts/AdminAuthContext';

export default function ProfileTab() {
  const navigate = useNavigate();
  const { user, logout } = useAdminAuth();

  return (
    <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
      <ListItemButton disabled>
        <ListItemIcon>
          <UserOutlined />
        </ListItemIcon>
        <ListItemText primary={user?.email || 'Admin'} />
      </ListItemButton>
      <ListItemButton
        onClick={() => {
          logout();
          navigate('/login');
        }}
      >
        <ListItemIcon>
          <LogoutOutlined />
        </ListItemIcon>
        <ListItemText primary="Выйти" />
      </ListItemButton>
    </List>
  );
}
